import { Analytika } from "@analytika/analytika-web";
import { v4 as uuidv4 } from "uuid";

if (typeof window !== "undefined") {
  const env = process.env.REACT_APP_ANALYTIKA_ENV;
  Analytika.init(env, false, {}, 10, 10);

  if (typeof document.visibilityState !== 'undefined') {
    document.addEventListener("visibilitychange", function () {
      // fires when user switches tabs, apps, goes to homescreen, etc.
      if (document.visibilityState === "hidden") {
        Analytika.getInstance().flush();
      }
    });
  }
}

class EventAnalytics {
  constructor() {
    this.invoiceId = undefined;
    this.sessionUuid = uuidv4();
    this.phoneNumber = undefined;
    this.phoneCountry = undefined;
    this.intent = undefined;
    this.page_name = undefined;
    this.flow_name = undefined;
    this.globalAttrs = {
      sessionUuid: this.sessionUuid,
      appName: process.env.REACT_APP_ANALYTIKA_EVENT_SOURCE,
      userAgent: navigator.userAgent,
      careem_identity_device_id: "not_available",
      client_id: "not_defined",
    };
  }

  publishV2(eventName, eventVersion, signature, eventData) {
    Analytika.publish({
      event_name: eventName,
      event_version: eventVersion ?? 1,
      signature: signature,
      event_trigger_time: new Date().getTime(),
      invoice_id: this.invoiceId,
      phone_number: this.phoneNumber,
      entered_phone_number: this.phoneNumber,
      intent: this.intent,
      flow_name: this.flow_name,
      page_name: this.getPageName(),
      ...(this.phoneCountry && { phone_country: this.phoneCountry }),
      ...this.globalAttrs,
      ...eventData,
    });
  }
  flush() {
    return Analytika.getInstance().flush();
  }
  setInvoiceId(invoiceId) {
    this.invoiceId = invoiceId;
  }

  setIntent(intent) {
    this.intent = intent;
  }

  setFlowName(flow_name) {
    this.flow_name = validFlowNames.includes(flow_name) ? flow_name : "phone";
  }

  setPageName(page_name) {
    this.page_name = page_name || "not_available";
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
  }

  setDeviceId(device_id) {
    this.globalAttrs.careem_identity_device_id = device_id;
  }

  setClientId(clientId) {
    this.globalAttrs.client_id = clientId || "not_defined";
  }

  getPageName() {
    return this.page_name || "not_available";
  }

  getSessionUuid() {
    return this.sessionUuid;
  }

  setPhoneCountry(phoneCountry) {
    this.phoneCountry = phoneCountry;
  }
}

const validFlowNames = [
  "apple",
  "biometric",
  "email",
  "google",
  "guest",
  "one_click",
  "phone",
];

const eventAnalytics = new EventAnalytics();
export default eventAnalytics;
